export enum ToastEvent {
    TOAST_FADE_IN = 'toast:fadeIn',
}
